import { useContext, useEffect } from 'react';
import FuseAuthorization from '@fuse/core/FuseAuthorization';
import FuseLayout from '@fuse/core/FuseLayout';
import FuseTheme from '@fuse/core/FuseTheme';
import { StyledEngineProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { Provider } from 'react-redux';
import { BrowserRouter, useNavigate } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import AppContext from './AppContext';
import { Auth } from './auth';
import routes from './fuse-configs/routesConfig';
import store from './store';
import { appContext } from './context/app-context';
import Loader from './common/Loader';
import { setNavigateRef } from './auth/store/userSlice';

// Captures the navigate function for use outside React components (Redux thunks)
function NavigateProvider({ children }) {
	const navigate = useNavigate();
	useEffect(() => { setNavigateRef(navigate); }, [navigate]);
	return children;
}

// Valor estable del contexto (las rutas no cambian en tiempo de ejecución).
const appContextValue = { routes };

const App = () => {
	const { loading } = useContext(appContext);

	return (
		<AppContext.Provider value={appContextValue}>
			<StyledEngineProvider injectFirst>
				<Provider store={store}>
					<LocalizationProvider dateAdapter={AdapterDateFns}>
						<Auth>
							<BrowserRouter>
								<NavigateProvider>
								<FuseAuthorization>								
									<FuseTheme>
									
										<SnackbarProvider
											maxSnack={5}
											anchorOrigin={{
												vertical: 'bottom',
												horizontal: 'right'
											}}
										>
											<Loader visible={loading} />
											<FuseLayout />
										</SnackbarProvider>
									</FuseTheme>
								</FuseAuthorization>
								</NavigateProvider>
							</BrowserRouter>
						</Auth>
					</LocalizationProvider>
				</Provider>
			</StyledEngineProvider>
		</AppContext.Provider>
	);
};

export default App;
